// Helpers per sincronizzare il router con il caricamento di clerk-js.
//
// NOTA: non usare Clerk.addListener per aspettare il caricamento — il callback
// riceve le Resources ({ client, session, user, organization }) e NON contiene
// `loaded`: una destrutturazione tipo ({ loaded }) resta undefined per sempre,
// la promise non si risolve mai e la navigazione iniziale resta appesa
// (pagina bianca senza errori). Qui si fa polling su Clerk.loaded, con un
// tetto massimo per non bloccare l'app se clerk-js non si carica affatto
// (es. script bloccato da un ad-blocker).

const POLL_INTERVAL_MS = 50;
const MAX_WAIT_MS = 10000;

export function waitForClerk({ pollIntervalMs = POLL_INTERVAL_MS, maxWaitMs = MAX_WAIT_MS } = {}) {
  return new Promise((resolve) => {
    let waited = 0;
    const check = () => {
      if (typeof window !== 'undefined' && window.Clerk?.loaded) return resolve();
      if (waited >= maxWaitMs) return resolve();
      waited += pollIntervalMs;
      setTimeout(check, pollIntervalMs);
    };
    check();
  });
}

export function getClerkAuth() {
  if (typeof window !== 'undefined' && window.Clerk) {
    // Prima del load, Clerk.user è undefined: normalizzato a null per non
    // scambiare un Clerk non ancora caricato per un utente loggato.
    const user = window.Clerk.user ?? null;
    return { isLoaded: !!window.Clerk.loaded, isSignedIn: user !== null, user };
  }
  return { isLoaded: false, isSignedIn: false, user: null };
}
